<section class="flex h-[64px] w-full min-w-full items-center justify-between bg-zinc-800 px-4 shadow shadow-zinc-800">
  <!-- Left content -->
  <div class="flex items-center gap-4">
    <a routerLink="/">
      <img
        src="assets/new-logo.svg"
        class="w-32 md:w-40" />
    </a>

    <!-- Project Info - Desktop -->
    @if (hasProject) {
      <div class="hidden items-center gap-4 border-l border-zinc-600 pl-4 lg:flex">
        <!-- Project Code -->
        <div class="flex items-center gap-2">
          <i class="material-symbols-outlined text-zinc-400">folder</i>
          <div class="flex flex-col">
            <span class="text-xs text-zinc-400">{{ 'i18n.navbar.project' | translate }}</span>
            <span class="text-sm font-medium text-zinc-100">{{ projectCode }}</span>
          </div>
        </div>

        <!-- Status -->
        <div class="status-dropdown-container relative flex items-center gap-2 border-l border-zinc-700 pl-4">
          <i class="material-symbols-outlined text-sm text-zinc-400">{{
            projectStatus === ProjectStatus.OnTrack ? 'check_circle' : 'warning'
          }}</i>
          <div class="flex flex-col">
            <span class="text-xs text-zinc-400">{{ 'i18n.navbar.status' | translate }}</span>
            <button
              class="flex cursor-pointer items-center text-left text-sm font-medium hover:underline"
              [class.text-green-400]="projectStatus === ProjectStatus.OnTrack"
              [class.text-orange-400]="projectStatus !== ProjectStatus.OnTrack"
              (click)="toggleStatusDropdown()">
              {{
                projectStatus === ProjectStatus.OnTrack
                  ? ('i18n.navbar.status.onTrack' | translate)
                  : projectStatus === ProjectStatus.OffTrack
                    ? ('i18n.navbar.status.offTrack' | translate)
                    : projectStatus === ProjectStatus.NotStarted
                      ? ('i18n.projectStatus.notStarted' | translate)
                      : projectStatus === ProjectStatus.Finished
                        ? ('i18n.projectStatus.finished' | translate)
                        : projectStatus === ProjectStatus.Discontinued
                          ? ('i18n.projectStatus.discontinued' | translate)
                          : ('i18n.projectStatus.notSet' | translate)
              }}
              <i class="material-symbols-outlined ml-1 text-sm">arrow_drop_down</i>
            </button>
          </div>

          <!-- Status Dropdown -->
          @if (statusDropdownOpen) {
            <div
              class="absolute left-0 top-full z-50 mt-2 w-56 rounded-lg border border-zinc-700 bg-zinc-800 shadow-lg">
              @for (option of statusOptions; track option.value) {
                <button
                  class="w-full px-4 py-2 text-left text-sm text-zinc-100 transition-colors first:rounded-t-lg last:rounded-b-lg hover:bg-zinc-700"
                  [class.bg-zinc-700]="projectStatus === option.value"
                  (click)="changeProjectStatus(option.value)">
                  {{ option.label | translate }}
                </button>
              }
            </div>
          }
        </div>

        <!-- Last Update -->
        <div class="flex items-center gap-2 border-l border-zinc-700 pl-4">
          <i class="material-symbols-outlined text-sm text-zinc-400">schedule</i>
          <div class="flex flex-col">
            <span class="text-xs text-zinc-400">{{ 'i18n.navbar.lastUpdate' | translate }}</span>
            <span class="text-sm font-medium text-zinc-100">{{ lastUpdate }}</span>
          </div>
        </div>
      </div>

      <!-- Project Info - Tablet -->
      <div class="hidden items-center gap-3 border-l border-zinc-600 pl-4 md:flex lg:hidden">
        <i class="material-symbols-outlined text-zinc-400">folder</i>
        <div class="flex flex-col">
          <span class="text-xs text-zinc-400">{{ 'i18n.navbar.project' | translate }}</span>
          <div class="flex items-center gap-2">
            <span class="text-sm font-medium text-zinc-100">{{ projectCode }}</span>
            <span
              class="rounded-full px-2 py-0.5 text-xs"
              [class.bg-green-500]="projectStatus === ProjectStatus.OnTrack"
              [class.text-green-400]="projectStatus === ProjectStatus.OnTrack"
              [class.bg-orange-500]="projectStatus !== ProjectStatus.OnTrack"
              [class.text-orange-400]="projectStatus !== ProjectStatus.OnTrack">
              {{ projectStatus === ProjectStatus.OnTrack ? '✓' : '!' }}
            </span>
          </div>
        </div>
      </div>
    }
  </div>

  <!-- Right content -->
  <div class="flex items-center gap-3">
    <!-- Mobile Project Code -->
    @if (hasProject) {
      <div class="flex items-center gap-2 md:hidden">
        <i class="material-symbols-outlined text-sm text-zinc-400">folder</i>
        <span class="text-sm font-medium text-zinc-100">{{ projectCode }}</span>
      </div>
    }

    <!-- Profile -->

    <div class="user-menu-container relative flex items-center gap-3">
      @if (me$ | async; as me) {
        <div class="hidden flex-col items-end md:flex">
          <span class="text-sm font-medium text-zinc-100"
            >{{ me.firstName === 'John' ? 'Super' : me.firstName }}
            {{ me.lastName === 'Doe' ? 'Admin' : me.lastName }}</span
          >
          <span class="text-xs text-zinc-400">{{ me.roles[0] }}</span>
        </div>
      }
      <button
        class="size-10 overflow-hidden rounded-full border-2 border-zinc-600 transition-all hover:border-blue-400"
        (click)="toggleUserMenu()">
        <img
          class="size-full object-cover"
          src="https://api.iconify.design/heroicons/user-circle-solid.svg?color=white" />
      </button>

      <!-- User Menu Dropdown -->
      @if (userMenuOpen) {
        <div
          class="absolute right-0 top-full z-[999] mt-2 w-48 rounded-lg border border-zinc-700 bg-zinc-800 shadow-lg">
          <button
            class="flex w-full items-center gap-2 rounded-lg px-4 py-2 text-left text-sm text-zinc-100 transition-colors hover:bg-zinc-700"
            (click)="logout()">
            <i class="material-symbols-outlined text-sm">logout</i>
            {{ 'i18n.navbar.logout' | translate }}
          </button>
        </div>
      }
    </div>
  </div>
</section>
